'use client'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import {
  Button,
  Drawer,
  DrawerProps,
  IconButton,
  Typography,
} from '@mui/material'
import { useTranslations } from 'next-intl'
import { useClearRefinements } from 'react-instantsearch'

type SearchFacetsDrawerProps = DrawerProps

export function SearchFacetsDrawer({
  onClose,
  children,
  ...props
}: SearchFacetsDrawerProps) {
  const { refine: clearRefinements } = useClearRefinements()
  const t = useTranslations('SearchFacetsDrawer')

  return (
    <Drawer
      {...props}
      anchor="left"
      onClose={onClose}
      classes={{
        paper: 'w-full max-w-full sm:max-w-[375px] flex-1 flex flex-col',
        ...props.classes,
      }}
    >
      <div className="flex h-full flex-col bg-white">
        <header className="flex items-center border-b border-divider px-2 py-4">
          <IconButton
            onClick={(e) => onClose?.(e, 'escapeKeyDown')}
            size="small"
            className="mr-1"
          >
            <ArrowBackIcon sx={{ fontSize: 16 }} className="text-mydra-black" />
          </IconButton>
          <Typography variant="subtitle1">{t('filters')}</Typography>
        </header>

        <div className="flex-1 overflow-y-auto px-3 py-4">{children}</div>

        <footer className="mt-auto flex items-center justify-between border-t border-divider p-3">
          <Button
            variant="outlined"
            onClick={() => clearRefinements()}
            className="hover:bg-gray-50 w-[172px] rounded-lg border border-divider bg-transparent px-3 py-2 text-sm font-medium leading-6 text-mydra-black"
          >
            {t('clear')}
          </Button>
          <Button
            variant="contained"
            onClick={(e) => onClose?.(e, 'escapeKeyDown')}
            className="w-[171px] rounded-lg bg-mydra-black px-3 py-2 text-sm font-medium leading-6 text-white hover:bg-mydra-black/90"
          >
            {t('done')}
          </Button>
        </footer>
      </div>
    </Drawer>
  )
}
